import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";

@Component({
  selector: "app-access-to-settings",
  templateUrl: "./access-to-settings.component.html",
  styleUrls: ["./access-to-settings.component.scss"],
})
export class AccessToSettingsComponent {
  @ViewChild("Firstkey") key1Element: ElementRef;
  @ViewChild("Secondkey") key2Element: ElementRef;
  @ViewChild("Thirdkey") key3Element: ElementRef;
  @ViewChild("Fourthkey") key4Element: ElementRef;
  @ViewChild("verifyKey") verifyKey: ElementRef;
  @Output() afterVerifAcess = new EventEmitter<any>();
  @Input() showVerifyAccountAccess = false;
  @Input() access_code = 9999;

  key1;
  key2;
  key3;
  key4;

  constructor() {
    //  [this.key1, this.key2, this.key3, this.key4] = this.access_code.toString().split('');
  }
  ngAfterViewInit(): void {}

  ngOnInit(): void {}

  focusONKey1() {
    setTimeout(() => {
      this.key1Element.nativeElement.focus();
    }, 0);
  }
  verify_AccessCode() {
    const codeGrouped = this.key1 + this.key2 + this.key3 + this.key4;
    console.log(codeGrouped == this.access_code);
    if (codeGrouped != this.access_code) {
      this.resetKeys();
      this.key1Element.nativeElement.focus();
    } else {
      this.showVerifyAccountAccess = false;
      this.afterVerifAcess.emit();
    }
    let status = codeGrouped == this.access_code;
  }

  onKeyInput(inputNumber: number) {
    const nextInputNumber = inputNumber + 1;
    const nextInputField = this[`key${nextInputNumber}Element`];
    if (
      nextInputField &&
      this[`key${inputNumber}`] &&
      this[`key${inputNumber}`].length > 0
    ) {
      nextInputField.nativeElement.focus();
    }
    if (inputNumber == 4 && this.key4) {
      this.verifyKey.nativeElement.focus();
    }
  }

  resetKeys() {
    this.key1 = null;
    this.key2 = null;
    this.key3 = null;
    this.key4 = null;
  }
}
